import { useCallback } from 'react';

import { useInstantSearch, usePagination } from 'react-instantsearch';

import { useTracking } from '@change-corgi/core/react/tracking';
import { getWindow } from '@change-corgi/core/window';

type Result = ModelHookResult<
	{
		currentPage: number;
		totalPages: number;
		shouldHidePagination: boolean;
	},
	{
		setPage: (selectedPage: number) => void;
	}
>;

export function usePaginationComponent(): Result {
	const { currentRefinement: currentPage, nbHits, nbPages, refine, canRefine } = usePagination();
	const { indexUiState } = useInstantSearch();
	const track = useTracking();

	return {
		data: {
			currentPage,
			totalPages: nbPages,
			shouldHidePagination: nbHits === 0 && nbPages === 0,
		},
		actions: {
			setPage: useCallback(
				(selectedPage: number) => {
					if (canRefine) {
						void track('search', {
							context: 'pagination',
							q: indexUiState.query || '',
						});
						refine(selectedPage - 1);
						getWindow().scrollTo(0, 0);
					}
				},
				[canRefine, indexUiState.query, refine, track],
			),
		},
	};
}
